<section class="content">
  <app-input-key-values [formData]="getDeviceUpdateInput()" />

  <span class="info">
    {{ 'common.alarm-rule.action.update-device.info' | translateSafe }}
  </span>
</section>


@if (this.isOverride()) {
  <section class="override">
    <div class="override-context">
      <span> {{ 'common.messages.alarm-rule.overrided' | translateSafe }} </span>
      <span> {{ 'common.messages.alarm-rule.default-value' | translateSafe }}:
        <br>
        <span [innerHtml]="getDefaultValueString"></span>
      </span>
    </div>

    <app-button-icon [iconName]="'replay'"
                     [label]="'common.actions.remove-override'"
                     [isTranslated]="true"
                     class="red"
                     (click)="removeOverride()" />
  </section>
}